export default (number, fixed) => number ? number.toFixed(fixed || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : number;